import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import * as firebase from 'firebase/app';
declare let jsPDF;
@Component({
  selector: 'app-barcode',
  templateUrl: './barcode.component.html',
  styleUrls: ['./barcode.component.css']
})
export class BarcodeComponent implements OnInit {
  @ViewChild('test1') el:ElementRef;
  constructor() { }
  numbers: any;
  maxLimit: number;
  ngOnInit() {      
    this.numbers = [];                                                                                                                                                                                                                                                                                                                                                                                                                                         
  }
  async getCount()
  {
    var count = 0;
    firebase.database().ref('count').once("value",(data)=>{
      
      if(data.val() == null)
      {
        count = 100000000;
        this.generateBarCode(count);
      }
      else
      {
        count = data.val();
        this.generateBarCode(count);
      }
    });
  }
  generateBarCode(count)
  {
    //console.log("count",count);
    for(let i=1;i <= this.maxLimit; i++)
    {
      var barcodeId = count + i;
      this.numbers.push(barcodeId);
    }
    if(barcodeId)
    {
      firebase.database().ref('count').set(barcodeId);
    }
  }
  generate(event){
    this.getCount(); 
    //console.log("event",event,this.maxLimit);                           
  }


  generatepdf()
  {
    var specialElementHandlers = {
      '#editor': function(element, renderer){
        return true;
      },
      '.controls': function(element, renderer){
        return true;
      }
    };
    var doc = new jsPDF('l', 'pt', 'a4');
    var margins = {
      top: 10,
      bottom: 10,
      left: 10,
      width: 300
    };

 doc.fromHTML( this.el.nativeElement, 10, 10, {
  'width': 500,
  'elementHandlers': specialElementHandlers
}, (bla) => {   
//doc.save('saveInCallback.pdf');

window.open(doc.output('bloburl'));

}, margins);
}

download(){
	var url = window.URL;
	var blobURL = "http://www.barcodesinc.com/generator/image.php?code=1234&style=197&type=C128B&width=250&height=80&xres=1&font=3";
	var a = document.createElement('a');
	a.download = "Barcode.png";
	a.href = blobURL;
	document.body.appendChild(a);
	a.click();
}
reset()
{
  this.numbers = [];
  this.maxLimit = null;
}
keyPress1(event)
  {
    const pattern = /[0-9\+\-\ ]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }
}



// WEBPACK FOOTER //
// E:/Office Projects/Paarsel/paarsel_business_web/paarsel_business_web/src/app/logistics-operations/barcode/barcode.component.ts